import React from 'react';
import { useHistory } from 'react-router-dom';
import { useVideoContext } from 'hooks/session';
import { Button } from '@chakra-ui/react';
import { Session } from "types";
import useGameLiftStreams from "hooks/session/useGameLiftStreams";

interface Props {
  session: Session;
}

const EndCallButton: React.FC<Props> = ({session}: Props) => {
  const { room } = useVideoContext();
  const { gameDisconnect } = useGameLiftStreams(session.id);
  const history = useHistory();

  const handleClick = (): void => {
    gameDisconnect();
    room!.disconnect();
    history.push('/');
  };

  return (
    <Button variant="red" size="lg" onClick={handleClick} data-cy-disconnect>
      End Call
    </Button>
  );
};

export default EndCallButton;
